// extracted by mini-css-extract-plugin
export var bgWhite = "styles-module--bgWhite--855ed";
export var tooltip = "styles-module--tooltip--6d937";
export var tooltipText = "styles-module--tooltipText--7f9b8";
export var tooltipTextOpen = "styles-module--tooltipTextOpen--5e2d9";